module.exports = __webpack_public_path__ + "img/WLGHZX_5.baf25d08.jpg";